module.exports = __webpack_public_path__ + "media/images/pc/brands/tvb/store_namba-524b6bebb40f087ca6fb33b0e906ff1b.jpg";